module.exports = __webpack_public_path__ + "667e35913dcf6bd8a92deac47b1b557d.png";